type Cart = {
    display: boolean,
    cartItems: number,
    url: string
}

export const defaultCart = {
    display: false,
    cartItems: 0,
    url: ""
}

export default Cart;